import { contentPrinciples } from "@/mocks/site";

export default function Principles() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-8">
        <div className="max-w-2xl">
          <p className="text-xs font-medium tracking-widest text-secondary-700">PRINCIPLES · 内容原则</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            我们坚持的四条底线
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            爆料类内容最容易滑向情绪化。为了让它保持可读与可信，我们给自己定了几条不太好走、但必须走的路。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-5 sm:grid-cols-2">
          {contentPrinciples.map((item) => (
            <article
              key={item.no}
              className="flex gap-5 rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
            >
              <span className="font-heading text-3xl font-black leading-none text-primary-200">
                {item.no}
              </span>
              <div>
                <h3 className="font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}